import React from 'react';
import CgRadixButton from 'modules/Common/ui/CgRadixButton';

/** The gate's 403 (phase 1) — not a query failure, a permissions answer. */
export const isForbidden = (error) => error?.response?.data?.code === 'ADMIN_FORBIDDEN';

export function AccessDeniedPanel() {
  return (
    <div
      data-testid="admin-access-denied"
      className="rounded-xl border border-slate-200 bg-white p-8 text-center"
    >
      <h2 className="text-lg font-semibold text-slate-900">Admin access required</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-slate-500">
        Your account is signed in but is not on the admin allowlist for this deployment. Ask an
        existing admin to grant you access.
      </p>
    </div>
  );
}

export function ErrorPanel({ title, onRetry }) {
  return (
    <div
      data-testid="admin-error-panel"
      className="rounded-xl border border-slate-200 bg-white p-8 text-center"
    >
      <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-slate-500">Request failed.</p>
      <CgRadixButton
        variant="secondary"
        label="Try again"
        onClick={onRetry}
        className="mt-4"
      />
    </div>
  );
}
